import { Form, Input, message, Select } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { AiOutlineUserSwitch } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import AuthenticationService from "../Services/AuthenticationService";
import { encryptPayload } from "../utils/encryptPassword";
import { APP_ROUTES } from "../PageRouting/pageRoutes";
import UserService from "../Services/UserService";
const docRoles = [
  { value: "doctor", label: "Doctor" },
  { value: "practice_admin", label: "Practice Admin" },
];

function DoctorLogin({ handleSignup }) {
  const navigate = useNavigate();
  const [doctorRoles, setDoctorRoles] = useState([]);
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [disable, setDisable] = useState(false);
  const [resendBtnClicked, setResendBtnClicked] = useState(false);
  const [isResendEnabled, setIsResendEnabled] = useState(true);
  const [disableTimer, setDisableTimer] = useState(true);
  const [timer, setTimer] = useState(180);
  const [selectedRole, setSelectedRole] = useState("");
  const [doctorloginType, setDoctorloginType] = useState(true);
  const [docOtpScreen, setDocOtpScreen] = useState(false);
  const [otp, setOtp] = useState();
  const [loginFlag, setLoginFlag] = useState(false);
  const verifyformRef = useRef();
  const inputRefs = useRef([]);
  const minutes = Math.floor(timer / 60);
  const seconds = timer % 60;

  useEffect(() => {
    setDoctorRoles(docRoles);
  }, []);

  useEffect(() => {
    if ((docOtpScreen || resendBtnClicked) && !disableTimer) {
      const timerInterval = setInterval(() => {
        setTimer((prevState) => {
          if (prevState === 0) {
            clearInterval(timerInterval);
            return 0;
          }
          return prevState - 1;
        });
      }, 1000);
      return () => {
        clearInterval(timerInterval);
        setTimer(180);
      };
    }
  }, [resendBtnClicked, docOtpScreen, disableTimer]);

  useEffect(() => {
    // written this useeffect to update the resend states and timer disabling
    // to handle resend button actions
    if (timer === 0) {
      setIsResendEnabled(true);
      setResendBtnClicked(false);
      setDisableTimer(true);
    }
  }, [timer]);

  const handleSelectionRole = (value) => {
    setSelectedRole(value);
  };

  const handleForgotClick = () => {
    navigate(APP_ROUTES.FORGOTPASSWORD, { state: { type: "doctor" } });
  };

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const validatePhoneNumber = (number) => /^\d{10}$/.test(number);

  const handleInputChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]$/.test(value) && index < 5) {
      inputRefs.current[index + 1].focus();
    } else if (!e.target.value && index >= 1) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleUserId = (e) => {
    const value = e.target.value;
    setUserId(value);
  };

  const generateOTP = async (userId) => {
    const tokenPayload = {
      password: "NA",
      userId: `U${userId}`,
    };

    try {
      const tokenRes =
        await AuthenticationService.TokenAuthentication(tokenPayload);
      if (tokenRes.data.error === "1") {
        message.error("Please enter a registered mobile number.");
        setDisable(false);
        return;
      }
      sessionStorage.setItem("access_token", tokenRes.data.access_token);
      let userPayload = {
        userId,
      };

      const response =
        await AuthenticationService.getUserMobileOtp(userPayload);
      if (response.data === 1) {
        setDocOtpScreen(true);
        setDisableTimer(false);
        setDisable(false);
      }
    } catch (e) {
      console.error(e);
      setDisable(false);
      if (e && e?.response?.data?.status === 404) {
        message.error("Please enter a registered mobile number.");
      }
    }
  };

  const handleOtpVerification = async (e) => {
    e.preventDefault();
    setDisable(true);
    const { one, two, three, four, five, six } =
      verifyformRef.current.getFieldsValue();
    let finalNum = one + two + three + four + five + six;
    setOtp(finalNum);
    const roleCode = handleDocConfirmation();
    if (roleCode === "") {
      const otpPayload = {
        userId,
        numVal: finalNum,
        type: "otp",
      };
      const encryptedPayload = encryptPayload(otpPayload);
      window.location.replace(
        `${process.env.REACT_APP_DOCTOR_URL}/authenticate?code=${encryptedPayload}`,
      );
    }
  };

  const handleResend = async (e) => {
    e.preventDefault();
    setIsResendEnabled(false);
    setResendBtnClicked(true);
    setDisableTimer(false);
    setTimer(180);

    try {
      let userPayload = {
        userId,
      };
      await AuthenticationService.getUserMobileOtp(userPayload);
    } catch (e) {
      console.error(e);
    }
  };

  const handleDoctorlogType = () => {
    setDoctorloginType(!doctorloginType);
    setLoginFlag(false);
  };

  const handleNumberValidation = () => {
    setDisable(true);
    if (validatePhoneNumber(userId)) {
      generateOTP(userId);
    } else {
      message.error("Enter a valid 10 digit registered mobile number.");
      setDisable(false);
    }
  };

  const handlePractLogin = () => {
    const otpPayload = {
      userId,
      numVal: otp,
      type: "otp",
    };

    const payload = {
      userId: userId,
      currVal: password,
      type: "password",
    };
    // If login is otp based doctorloginType will be true. So we will construct payload accordingly.
    const encryptedPayload = doctorloginType
      ? encryptPayload(otpPayload)
      : encryptPayload(payload);

    if (selectedRole === "practice_admin") {
      window.location.replace(
        `${process.env.REACT_APP_ADMIN_URL}/authenticate?code=${encryptedPayload}`,
      );
    } else if (selectedRole === "doctor") {
      window.location.replace(
        `${process.env.REACT_APP_DOCTOR_URL}/authenticate?code=${encryptedPayload}`,
      );
    }
  };
  const COUNTRYCODE = process.env.REACT_APP_COUNTRYCODE || "";

  const handleDocConfirmation = async () => {
    let mobile;
    let email;
    mobile = validatePhoneNumber(userId);
    if (!mobile) email = validateEmail(userId);
    const payload = {};
    if (mobile) payload.mobile = mobile ? userId : "";
    else if (email) payload.email = email ? userId : "";
    try {
      if (COUNTRYCODE) {
        payload.country = COUNTRYCODE;
      }
      const response = await UserService.getDoctors(payload);
      if (response.data && response.data.length === 0) {
        message.error(
          "No user found. Please check your credentials and try again.",
        );
        return;
      }
      if (
        response.data &&
        response.data.length > 0 &&
        response.data[0].userType !== "P"
      ) {
        message.error(
          "No user found. Please check your credentials and try again.",
        );
        return;
      }
      if (response.data[0].rolecode !== "") {
        setLoginFlag(true);
      }
      return response.data[0].rolecode;
    } catch (e) {
      console.error(e);
    }
  };

  const handleEmailLogin = async () => {
    if (!validatePhoneNumber(userId) && !validateEmail(userId)) {
      message.error(
        "Please enter a valid email or 10-digit registered mobile number!",
      );
      return;
    }

    try {
      const roleCode = await handleDocConfirmation();
      if (roleCode === "") {
        const payload = {
          userId: userId,
          currVal: password,
          type: "password",
        };
        const encryptedPayload = encryptPayload(payload);
        window.location.replace(
          `${process.env.REACT_APP_DOCTOR_URL}/authenticate?code=${encryptedPayload}`,
        );
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      <div>
        {
          //if doctorlogintype is true it will be otp based login else password based login
          doctorloginType ? (
            <div>
              {
                //if docotpscreen is true we will show otp entering screen. else show the mobile number entering field
                docOtpScreen ? (
                  <>
                    {!loginFlag && (
                      <>
                        <div>
                          <label className="text-lg font-medium">OTP </label>
                          <span style={{ color: "#FF000F" }}>*</span>
                        </div>
                        <div className="p-3">
                          <p className="text-sm font-extralight">
                            OTP will expire in{" "}
                            <span className="text-base text-iconBlue">{`${String(
                              minutes,
                            ).padStart(2, "0")}:${String(seconds).padStart(
                              2,
                              "0",
                            )}`}</span>
                            .
                          </p>
                        </div>
                      </>
                    )}
                    <Form ref={verifyformRef}>
                      {loginFlag ? (
                        <Form.Item
                          name={"rolecode"}
                          className={`${loginFlag ? "block" : "hidden"}`}
                        >
                          <Select
                            className="w-56 h-10"
                            placeholder="Select Role"
                            onChange={handleSelectionRole}
                            options={doctorRoles.map((item, idx) => {
                              return {
                                label: item.label,
                                value: item.value,
                                key: idx,
                              };
                            })}
                          />
                        </Form.Item>
                      ) : (
                        <div className="w-full flex gap-2 items-center justify-evenly">
                          {[...Array(6)].map((_, index) => (
                            <Form.Item
                              key={index}
                              name={
                                ["one", "two", "three", "four", "five", "six"][
                                  index
                                ]
                              }
                              className="w-1/5"
                              rules={[
                                {
                                  pattern: /^[0-9]{1}$/,
                                },
                              ]}
                            >
                              <Input
                                maxLength={1}
                                ref={(el) => (inputRefs.current[index] = el)}
                                onChange={(e) => handleInputChange(e, index)}
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                className="outline-none border rounded-lg border-borderColor p-3 text-center font-medium text-xl"
                              />
                            </Form.Item>
                          ))}
                        </div>
                      )}
                    </Form>
                    <div className="flex items-center gap-2">
                      {loginFlag ? (
                        <button
                          className="w-full p-3 bg-[#189FAA] text-white rounded-lg font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
                          onClick={handlePractLogin}
                        >
                          Proceed
                        </button>
                      ) : (
                        <>
                          <button
                            className={`w-full p-3 bg-lightBlue rounded-lg font-semibold disabled:cursor-not-allowed`}
                            disabled={!isResendEnabled}
                            onClick={handleResend}
                          >
                            Resend OTP
                          </button>
                          <button
                            disabled={disable}
                            className="w-full p-3 bg-[#189FAA] text-white rounded-lg font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
                            onClick={handleOtpVerification}
                          >
                            Verify OTP
                          </button>
                        </>
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="text-left w-[100%]">
                      <Form.Item name={"userCode"}>
                        <Input
                          type="text"
                          placeholder="UserId Or Mobile"
                          suffix={
                            <AiOutlineUserSwitch className="h-4 w-4 text-gray-500" />
                          }
                          className="h-10 w-full px-2 border border-gray-500 appearance-none bg-none  focus:outline-none focus:ring-0 disabled:opacity-50"
                          style={{ background: "none" }}
                          value={userId}
                          onChange={handleUserId}
                        />
                      </Form.Item>
                    </div>
                    <div className="text-center mt-4 w-[100%]">
                      <button
                        disabled={disable}
                        onClick={handleNumberValidation}
                        className="w-full px-5 py-2 bg-[#189FAA] text-white rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        GET OTP
                      </button>
                    </div>
                  </>
                )
              }
            </div>
          ) : (
            <>
              <div className="text-left w-[100%]">
                <Form.Item name={"userCode"}>
                  <Input
                    type="text"
                    placeholder="UserId Or Mobile"
                    suffix={
                      <AiOutlineUserSwitch className="h-4 w-4 text-gray-500" />
                    }
                    className="h-10 w-full px-2 border border-gray-500 appearance-none bg-none  focus:outline-none focus:ring-0 disabled:opacity-50"
                    style={{ background: "none" }}
                    value={userId}
                    onChange={handleUserId}
                  />
                </Form.Item>
              </div>
              <div className="mt-5 text-left w-[100%]">
                <Form.Item name={"passWord"}>
                  <Input.Password
                    type="password"
                    placeholder="Password"
                    className="h-10 w-full px-2 border border-gray-500 appearance-none bg-none focus:outline-none focus:ring-0 "
                    style={{ background: "none" }}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </Form.Item>
                <Form.Item
                  name={"rolecode"}
                  className={`${loginFlag ? "block" : "hidden"}`}
                >
                  <Select
                    className="w-56 h-10"
                    placeholder="Select Role"
                    onChange={handleSelectionRole}
                    options={doctorRoles.map((item, idx) => {
                      return {
                        label: item.label,
                        value: item.value,
                        key: idx,
                      };
                    })}
                  />
                </Form.Item>
                <div
                  onClick={handleForgotClick}
                  className="text-end text-sm font-semibold text-[#189FAA] hover:underline cursor-pointer mt-2"
                >
                  Forgot Password?
                </div>
              </div>
              <div className="text-center mt-4 w-[100%]">
                {loginFlag ? (
                  <button
                    onClick={handlePractLogin}
                    className="w-full px-5 py-2 bg-[#189FAA] text-white rounded-md"
                  >
                    Proceed
                  </button>
                ) : (
                  <button
                    onClick={handleEmailLogin}
                    className="w-full px-5 py-2 bg-[#189FAA] text-white rounded-md"
                  >
                    Login
                  </button>
                )}
              </div>
            </>
          )
        }

        {!docOtpScreen && (
          <div className="w-full flex justify-center items-center mt-6">
            <p
              onClick={handleDoctorlogType}
              className="text-sm font-semibold text-[#189FAA] hover:underline cursor-pointer px-2"
            >
              {doctorloginType ? "Login with password" : "Login with mobile"}
            </p>
          </div>
        )}
        <div className="w-full flex items-center mt-6">
          <p className="text-sm font-semibold">
            Don't have an account?{" "}
            <span
              className="hover:underline text-[#189FAA] cursor-pointer px-2"
              onClick={() => handleSignup("doctor")}
            >
              Sign Up
            </span>
          </p>
        </div>
      </div>
    </>
  );
}

export default DoctorLogin;
